document.addEventListener('DOMContentLoaded', function() {
  function toggleSliders() {
    var desktopSlider = document.querySelector('.desktop-slider');
    var mobileSlider = document.querySelector('.mobile-famous-slider-container');

    if (!desktopSlider || !mobileSlider) return;
    if (window.innerWidth <= 768) { // Adjust the breakpoint as needed
      desktopSlider.classList.add('hidden');
      mobileSlider.classList.remove('hidden');
    } else {
      desktopSlider.classList.remove('hidden');
      mobileSlider.classList.add('hidden');
    }
  }

  function initSliderDots() {
    var sliderItems = document.querySelectorAll('.famous-slider-item');
    var dots = document.querySelectorAll('.famous-dot');
    var sliderWrapper = document.querySelector('.mobile-famous-slider-container');
    var currentIndex = 0;
    if (!sliderWrapper || !sliderItems.length) return;

    function updateActiveDot(index) {
      dots.forEach(function(dot, idx) {
        dot.className = dot.className.replace(' active-dot', '');
        if (idx === index) {
          dot.className += ' active-dot';
        }
      });
      currentIndex = index;
    }

    function handleDotClick(event) {
      var index = Array.prototype.indexOf.call(dots, event.target);
      sliderWrapper.scrollTo({
        left: sliderItems[index].offsetLeft,
        behavior: 'smooth'
      });
      updateActiveDot(index);
    }

    function handleScroll() {
      var slideWidth = sliderItems[0].offsetWidth;
      var scrollPosition = sliderWrapper.scrollLeft;
      var newIndex = Math.round(scrollPosition / slideWidth);
      if (newIndex !== currentIndex) {
        updateActiveDot(newIndex);
      }
    }

    // Attach event listeners to dots
    dots.forEach(function(dot) {
      dot.addEventListener('click', handleDotClick);
    });

    // Attach scroll event listener
    sliderWrapper.addEventListener('scroll', handleScroll);

    // Initially update the active dot
    updateActiveDot(0);
  }

  // Select the radio inputs for the frame colors and other variants
  var variantSelectors = [
    'input[name="Varijanta"]', 
    'input[name="Veličina"]', 
    'input[name="Okvir"]'
  ];
  
  // Combine selectors into a single query string
  var combinedSelectors = variantSelectors.join(', ');

  // Select all elements matching any of the selectors
  var variantInputs = document.querySelectorAll(combinedSelectors);
  
  // Select the span that displays the current frame color
  var frameColorLabelSpan = document.querySelector('.variant__label-info span[data-variant-color-label]');
  
  // Function to update the frame color label span
  function updateFrameColorLabel() {
    // Find the selected radio input
    var selectedInput = document.querySelector('input[name="Okvir"]:checked');
    
    // If a radio input is selected, update the frame color label span
    if (selectedInput && frameColorLabelSpan) {
      frameColorLabelSpan.textContent = selectedInput.value;
    }

    // Posteria 2026-10-20: the catalogue products carry image sets (one group per frame, the room photo as
    // the variant image), and the theme itself shows that photo on every variant change. The dot jump below
    // was written for the previous products (image 1 bare, 2 black, 3 white) and only runs for those.
    if (selectedInput && !document.querySelector('.product__thumb-item[data-group]')) {
      updateMainImage(selectedInput.value);
    }
  }

  // Function to update the main image and thumbnail based on the selected frame color
  function updateMainImage(frameColor) {
    var dataIndex;
    
    switch(frameColor) {
      case 'Bez okvira':
        dataIndex = 0;
        break;
      case 'Crni':
        dataIndex = 1;
        break;
      case 'Bijeli':
        dataIndex = 2;
        break;
      case 'Drvena rama':
//        dataIndex = 3;
        dataIndex = 0;
        break;
      default:
        return; // Canvas and unknown finishes use the theme's actual variant image.
    }

    var dots = document.querySelectorAll('.flickity-page-dots .dot');
    var activeDot = dots[dataIndex];
    if (activeDot) {
        // Simulate click on the dot
        activeDot.click();
    }
  }
  
  // Add event listeners to the radio inputs to update the frame color label span when changed
  variantInputs.forEach(function(input) {
    input.addEventListener('change', updateFrameColorLabel);
  });
  
  // Run on page load
  toggleSliders();
  initSliderDots();
  updateFrameColorLabel();

  // Run on window resize
  window.addEventListener('resize', toggleSliders);
});
